module.exports = __webpack_public_path__ + "static/media/people_running.8e0a81d5.jpeg";